import React from 'react';
import { Helmet } from 'react-helmet-async';

import { snippet } from 'src/modules/homeownerApp/components/Hotjar/snippet';

export const Hotjar = () => (
  <Helmet>
    <script>{snippet}</script>
  </Helmet>
);
